export default "__VITE_ASSET__DvbcAXVz__"